import "./patientMeasurement.scss";
import "../../steps/forms.scss";
import FormTitle from "../../components/formTitle/FormTitle";
import MuiRadio from "../../components/radio/MuiRadio";
import InputTextField from "../../components/textField/InputTextField";
import OrderFormStep from "../../common/OrderFormStep";
import FieldState from "../../common/FieldState";
import axios from "axios";
import Config from "../../common/Config";
import Button from "../../components/button/Button";
import SecondaryButton from "../../components/button/SecondaryButton";
import { CreateNotification } from "../../components/notification/Notification";
import SaveAsDraft from "../../components/modal/SaveAsDraft";
import { Button as MuiButton } from "@mui/material";
import { FileUploadIcon } from "../../icons/svg";

class TTRevoStandardMeasurement extends OrderFormStep {
  constructor(props) {
    super(props);

    this.fromCADFileId = 111;

    this.uomMetric = 67;
    this.conversionFactor = 25.4;

    this.shortenId = 29;
    this.extendId = 30;

    this.nextCartQueueIndex=0;
    this.displayedCartIndex=0;

    this.defaults = {
      socketFinish: {name: "Carbon Finish", id: 20},
      insert: {name: "Black Flexible Inner", id: 177},
      lock: {name: "Genesis Bull Dog Lock", id: 46},
      revoFit: {name: "Posterior Single Panel", id: 158},
    }; 

    this.state = {
      estimatedShipDate: null,
      socketMaterials: [],
      isSubmit: false,
      selectedValue: 0,
      patientId: null,
      formState: {
        cadFile: new FieldState(false),
        cadFileName: new FieldState(false),
        castShippedSeparately: new FieldState(false),
        scanFileName: new FieldState(false),
        socketMaterial: new FieldState(true),
        itemsSentIn: new FieldState(true),
        notes: new FieldState(false),
      },
    };

    this.onFileChange = this.onFileChange.bind(this);
    this.onCheckChange = this.onCheckChange.bind(this);
    this.getNextCartQueueIndex = this.getNextCartQueueIndex.bind(this);
    this.shouldDisplayCart = this.shouldDisplayCart.bind(this);
  }

  getNextCartQueueIndex() {
    return this.nextCartQueueIndex++;
  }

  shouldDisplayCart(index) {
    if(index >= this.displayedCartIndex) {
      this.displayedCartIndex = index;
      return true;
    }

    return false;
  }

  
  loadCart() {
    let cart = [];

    let addToCart = (options, selectedId, sourceId) => {
      let item = options.filter(x => x.id===selectedId)[0];
      if(item && item.partNumbers && item.partNumbers.length > 0) {
        item.partNumbers.forEach(part => {
          cart.push({
            name: item.displayName,
            partNumber: part,
            quantity: 1,
            price: -1,
            sourceId: sourceId
          });
        });
      } else {
        cart.push({
            name: null,
            partNumber: null,
            quantity: 0,
            price: 0,
            sourceId: sourceId
          });
      }
    }


    addToCart(this.state.socketMaterials, this.state.formState.socketMaterial.value, "socketMaterial");
    
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };
    config.params = {
      cart: cart.map(x => x.partNumber)
    }

    const index = this.getNextCartQueueIndex();

    return this.loadShipDate()
      .then(r1 => {
        return axios.get(
          Config.baseApiUrl + "price/" + this.props.formTypeId,
          config
        ).then(response => {
          let data = response.data
  
          cart = cart.map(c => {
            return {
              name: c.name,
              partNumber: c.partNumber,
              quantity: c.quantity,
              price: data.filter(x => x.partNumber === c.partNumber)[0]?.price,
              sourceId: c.sourceId
            }
          });

          cart = cart.concat(data.filter(d => d.sourceId !== null).map(d => {
            return {
              name: d.name,
              partNumber: d.partNumber,
              quantity: d.quantity,
              price: d.price,
              sourceId: d.sourceId
            }
          }));
          
          if(this.shouldDisplayCart(index)) {
            this.props.setTempCart(cart);
          }
        }).catch(error =>{
          console.log(error)
        })
      });
  }

  onFileChange(e) {
    const file = e.target.files[0];
    if (file === undefined) {
      return null;
    }
    if (file.size >= 8000000) {
      CreateNotification("File size must be less than 8 MB", "error");
      return null;
    }
    let formState = this.state.formState;
    const previouslyUploadedFileName = formState.cadFileName.value;
    formState.cadFileName.value = "";
    const newFileName = this.renameFile(file);
    if (newFileName !== null) {
      formState.cadFile.value = newFileName;
      formState.cadFile.isRequired = this.isFromCADFileSelected();
    } else {
      formState.cadFileName.value = previouslyUploadedFileName;
    }
    this.setState({ formState: formState, hasDataChanged: true });
  }

  renameFile(file) {
    const oldName = file?.name;
    if (oldName === undefined) {
      return null;
    }
    const oldFileType = oldName.split(".").slice(-1)[0];
    if (this.validFileTypes(oldFileType)) {
      const newName = Date.now() + "_" + this.state.patientId + "." + oldFileType;
      this.state.formState.cadFileName.value = newName;
      return new File([file], newName);
    } else {
      CreateNotification("File type must be .stl, .obj or .aop", "error");
      return null;
    }
  }

  validFileTypes(oldFileType) {
    return (oldFileType === 'stl' || oldFileType === 'obj' || oldFileType === 'aop')
  }

  isFromCADFileSelected() {
    return this.state.formState.socketMaterial === this.fromCADFileId;
  }

  onCheckChange(e) {
    let formState = this.state.formState;
    formState.castShippedSeparately.value = e.target.checked;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  componentDidMount() {
    this.loadData();
  }

  async loadShipDate() {
    try {
      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
      };
      let estimatedShipDate = (
        await axios.get(
          Config.baseApiUrl + "shipDate/" + this.props.formTypeId,
          config
        )
      ).data;

      this.setState({
        estimatedShipDate: estimatedShipDate,
      });
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    this.setState({ isLoaded: true });
  }

  async loadData() {
    try {
      this.setState({

        socketMaterials: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "socketMaterial" } }
          )
        ).data,
      });

      let formState = this.state.formState;
      let headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
      };
      let cadFileConfig = {
        headers: headers,
      };

      const cadFile = (
        await axios.get(
          Config.baseApiUrl + "cadFiles/" + this.props.formTypeId,
          cadFileConfig
        )
      ).data;
      formState.cadFileName.value = cadFile !== null ? cadFile.cadFileName : "";

      let patientInfo1Config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
        params: {
          fieldNames: ["patientInfo1UOM", "height", "weight"],
        },
      };

      if (this.props.uniqueId != null) {
        patientInfo1Config.headers.UniqueId = this.props.uniqueId;
      }

      let patientInfo1Data = (
        await axios.get(
          Config.baseApiUrl + "patientInfo1s/" + this.props.formTypeId,
          patientInfo1Config
        )
      ).data.patientId;

      this.setState({
        patientId: patientInfo1Data
      })

      this.loadShipDate();
      let config = {
        headers: headers,
        params: {
          fieldNames: [
            "scanFileName",
            "socketMaterial",
            "itemsSentIn",
            "notes",
          ],
        },
      };

      const { data } = await axios.get(
        Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
        config
      );

      formState.socketMaterial.value = data.find(
        (fi) => fi.fieldName === "socketMaterial"
      ).fieldOptionId;


      formState.itemsSentIn.value = data.find(
        (fi) => fi.fieldName === "itemsSentIn"
      ).stringData;
      formState.notes.value = data.find(
        (fi) => fi.fieldName === "notes"
      ).stringData;


      formState.scanFileName.isRequired = this.isFromScanSelected();

      this.setState({ formState: formState });
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    

    this.setState({ isLoaded: true });
  }

  getFieldInputPromise() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let fieldInputData = [];

    fieldInputData.push({
      fieldName: "socketFinish",
      fieldOptionId: this.defaults.socketFinish.id,
    });
    fieldInputData.push({
      fieldName: "lock",
      fieldOptionId: this.defaults.lock.id,
    });
    fieldInputData.push({
      fieldName: "insertMaterial",
      fieldOptionId: this.defaults.insert.id,
      booleanData: true,
    });
    fieldInputData.push({
      fieldName: "revoFit",
      fieldOptionId: this.defaults.revoFit.id,
      booleanData: true,
    });

    fieldInputData.push({
      fieldName: "itemsSentIn",
      stringData: this.state.formState.itemsSentIn.value,
    });

    fieldInputData.push({
      fieldName: "notes",
      stringData: this.state.formState.notes.value,
    });


    fieldInputData.push({
      fieldName: "socketMaterial",
      fieldOptionId: this.state.formState.socketMaterial.value,
    });

    return axios.post(
      Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
      fieldInputData,
      config
    )
  }

  saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let promises = [];


    if (this.state.formState.cadFile.value !== "") {
      const formData = new FormData();

      formData.append(
        "cadFile",
        this.state.formState.cadFile.value,
        this.state.formState.cadFile.value.name
      );

      promises.push(
        axios.post(
          Config.baseApiUrl + "cadFiles/" + this.props.formTypeId,
          formData,
          config
        )
      );
    }

    if (this.validateData().isValid) {
      promises.push(this.getFieldInputPromise());
      axios
        .all(promises)
        .then(
          axios.spread((res, res2) => {
            if (res2) {
              if (
                (res.status === 200 || res.status === 204) &&
                (res2.status === 200 || res2.status === 204)
              ) {
                this.props.handleNext(this?.props?.currentIndex);
                this.setState({ isLoading: false });
                CreateNotification("Submitted", "success");
              }
            } else {
              if (res.status === 200 || res.status === 204) {
                this.props.handleNext(this?.props?.currentIndex);
                this.setState({ isLoading: false });
                CreateNotification("Submitted", "success");
              }
            }
          })
        )
        .catch((error) => {
          console.log(error);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({
        isSubmit: true,
      });
      CreateNotification(this.validateData().errorMessage, "error");
      this.setState({ isLoading: false });
    }
  }

  formatShipDate(shipDate) {
    if (!shipDate) {
      return "";
    }
    return `${shipDate.month}/${shipDate.day}/${shipDate.year}`;
  }

  handleSliderChange(newValue) {
    this.props.setActiveInnerStep(5);
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  convertToISOString(dateString) {
    const dateParts = dateString.split("-");
    const convertedDate = new Date(
      dateParts[0],
      dateParts[1] - 1,
      dateParts[2]
    );

    return convertedDate;
  }
  formatDateToString(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    const cadFileUploader = (
      <div className="fileUpload">
        <span>File size must be less than 8 MB</span>
        <MuiButton
          component="label"
          variant="contained"
          startIcon={<FileUploadIcon />}
        >
          Upload File
          <input
            type="file"
            style={{ display: "none" }}
            onChange={this.onFileChange}
          />
        </MuiButton>
        <span>{this.state.cadFileName?.value}</span>
      </div>
    );

    return (
      <div className="tfMeasuremnet">
        <div className="checkFormWrapper">
          <FormTitle
            title="Patient Measurements"
            description=""
          />

          <form className="checkform" onSubmit={e => {e.preventDefault()}}>

            <div>
              <MuiRadio
                options={this.state.socketMaterials.map((option) => ({
                  displayName: option.displayName,
                  id: option.id,
                  partNumber: option.partNumber,
                  content: (option.id === this.fromCADFileId) ? cadFileUploader : ""
                }))}
                label="Socket Material"
                defaultValue={this.state.formState.socketMaterial.value}
                required={this.state.formState["socketMaterial"].isRequired}
                error={
                  this.handleError("socketMaterial") && this.state.isSubmit
                }
                onChange={(e) => {
                  this.props.setActiveInnerStep(2);
                  this.onRadioChange(e, "socketMaterial");
                }}
              />
            </div>

            <div className="msgBox fieldBorder msgBoxWidth">
              <div className="possibelDate">
                <div><h4 className="headLable"><b>Earliest Ship Date</b>: {this.formatShipDate(this.state.estimatedShipDate)}</h4>
                </div>
              </div>
              <InputTextField
                label="Items sent in with socket"
                variant="outlined"
                placeholder="Type Something here..."
                type="text"
                width="800px"
                multiline
                rows={6}
                value={this.state.formState.itemsSentIn.value}
                required={this.state.formState["itemsSentIn"].isRequired}
                error={this.handleError("itemsSentIn") && this.state.isSubmit}
                onChange={(e) => {
                  this.onInputChange(e, "itemsSentIn");
                  this.props.setActiveInnerStep(4);
                }}
              />
            </div>

            <div className="msgBox fieldBorder msgBoxWidth">
              <h4 className="headLable"> Notes</h4>
              <InputTextField
                label="Other Notes"
                variant="outlined"
                placeholder="Type Something here..."
                type="text"
                width="800px"
                multiline
                rows={6}
                value={this.state.formState.notes.value}
                error={this.handleError("notes") && this.state.isSubmit}
                onChange={(e) => {
                  this.onInputChange(e, "notes");
                  this.props.setActiveInnerStep(5);
                }}
              />
            </div>

            <div className="fieldBorder">
              <div className="msgBox msgBoxWidth">
                <h4 className="headLable"><b>Socket Finish:</b></h4>
                <p>{this.defaults.socketFinish.name}</p>
              </div>
              <div className="msgBox msgBoxWidth">
                <h4 className="headLable"><b>Insert:</b></h4>
                <p>{this.defaults.insert.name}</p>
              </div>
              <div className="msgBox msgBoxWidth">
                <h4 className="headLable"><b>Lock:</b></h4>
                <p>{this.defaults.lock.name}</p>
              </div>
              <div className="msgBox msgBoxWidth">
                <h4 className="headLable"><b>Revofit® Style:</b></h4>
                <p>{this.defaults.revoFit.name}</p>
              </div>
            </div>

            <div className="msgBox fieldBorder msgBoxWidth">
              <h4 className="headLable"><b>Revofit® Reel Placement</b></h4>
              <p>In most cases, sockets of a height equal to or greater than 7.25 inches (18.5 cm) from the distal
                end of the finished socket to the inferior posterior trim will have the reel centered in the window.
                Sockets shorter than 7.25 inches (18.5 cm) will have the reel positioned at the distal, anterior-medial
                aspect of the socket.
              </p>

              <h4 className="headLable"><b>Revofit® Window Height</b></h4>
              <p>The window will start ~1 inch (2.5 cm) below the lowest portion of the posterior trim.
                It will not extend further than 2.25 inches (5.7 cm) from the distal end of the finished socket.
              </p>

              <h4 className="headLable"><b>Revofit® Window Width</b></h4>
              <p>The window will be centered on the posterior trim. It will not extend further than 3/4 inch (2 cm)
                from the vertical walls of the cutout.
              </p>

              <p> <b>Important Note: </b>
                While we strive to follow these placement standards, the utimate location of the dial and window may be 
                adjusted slightly to ensure all components fit comfortably within the space limitations of your socket.
                This ensures optimal functionality and user experience.
              </p>
            </div>

          </form>
        </div>
        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => this.props.handleBack(this.props.currentIndex - 1)}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                this.setState({ isLoading: true });
                this.saveData();
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
      </div>
    );
  }
  isRevoFitEnabled() {
    return this.state.formState.revoFitEnabled.value;
  }

  isAdditionalWindowSelected() {
    return this.state.formState.revoFit.value[this.additionalWindowId];
  }


  isPRSOption(option) {
    return option.includes("PRS");
  }

}

export default TTRevoStandardMeasurement;
